(function () {
  // Shared carousel logic for both about and hero carousels
  function initCarousel(root) {
    var track = root.querySelector('[data-about-track], [data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-about-slide], [data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-about-dot], [data-hero-dot]'));
    var previousButton = root.querySelector('[data-about-prev], [data-hero-prev]');
    var nextButton = root.querySelector('[data-about-next], [data-hero-next]');
    var currentIndex = 0;
    var timer = null;
    var interval = 6200;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setSlide(index) {
      if (!track || !slides.length) {
        return;
      }

      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

      // Determine bg data attribute key
      var bgKey = root.hasAttribute('data-hero-carousel') ? 'heroBg' : 'aboutBg';
      var bgVal = slides[currentIndex].dataset[bgKey] || (root.hasAttribute('data-hero-carousel') ? '#10204F' : '#5ec9dc');
      root.style.setProperty('--chicaup-about-bg', bgVal);

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button').forEach(function (item) {
          item.tabIndex = isActive ? 0 : -1;
        });
      });

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAuto() {
      if (reduceMotion || timer || slides.length < 2) {
        return;
      }

      timer = window.setInterval(function () {
        setSlide(currentIndex + 1);
      }, interval);
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        stopAuto();
        setSlide(currentIndex - 1);
        startAuto();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        stopAuto();
        setSlide(currentIndex + 1);
        startAuto();
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        stopAuto();
        setSlide(dotIndex);
        startAuto();
      });
    });

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);

    setSlide(0);
    startAuto();
  }

  // Initialize all carousels
  var carousels = document.querySelectorAll('[data-about-carousel], [data-hero-carousel]');
  Array.prototype.forEach.call(carousels, initCarousel);
})();